import { POINTS_DASHBOARD_TAB, VEERSA_POINTS_TAB } from "./constants/veersaPointsConstants";

/** Append Veersa Points tabs to Training and Session (integrated, not standalone sidebar). */
export function buildTrainingAndSessionTabs(userData) {
  const role = userData?.data?.roleName;
  const base =
    role === "Operational Admin"
      ? ["TRAINING AND SESSION"]
      : [...(userData?.data?.tabs?.trainingAndSession || [])];

  const tabs = [...base];
  if (!tabs.includes(VEERSA_POINTS_TAB)) {
    tabs.push(VEERSA_POINTS_TAB);
  }
  if (role === "Admin" && !tabs.includes(POINTS_DASHBOARD_TAB)) {
    tabs.push(POINTS_DASHBOARD_TAB);
  }
  return tabs;
}

export { VEERSA_POINTS_TAB, POINTS_DASHBOARD_TAB };
